module.exports = ".titulo{\r\n  display:flex;\r\n}"